import React from 'react';

export const FourOhFour = () => {
    return <div>Not found</div>;
};
